import { Outlet } from 'react-router-dom'
import { useTheme } from '@/contexts/ThemeContext'
import { cn } from '@/lib/utils'
import SuperProfNoteButton from '@/components/common/SuperProfNoteButton'
import EditModeToggle from '@/components/edit/EditModeToggle'

/**
 * Layout sin sidebar para páginas de contenido y ejercicios.
 * Maximiza el espacio disponible para el contenido principal.
 */
export default function ContentLayout() {
  const { ageTheme } = useTheme()

  return (
    <div className={cn('min-h-screen bg-background', `theme-${ageTheme}`)}>
      <Outlet />
      <SuperProfNoteButton />
      <EditModeToggle />
    </div>
  )
}
